import { Capacitor } from '@capacitor/core';

const IOS_NATIVE_VIEWPORT_CONTENT = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

export function configureNativeViewport(doc: Document = document): void {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
    return;
  }

  const viewportMeta = doc.querySelector('meta[name="viewport"]');
  if (!viewportMeta) {
    return;
  }

  viewportMeta.setAttribute('content', IOS_NATIVE_VIEWPORT_CONTENT);
}

export { IOS_NATIVE_VIEWPORT_CONTENT };